import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["loading", "data", "previousData", "error"];
const _unique = definitions => {
  const names = {};
  return definitions.filter(definition => {
    if (definition.kind !== 'FragmentDefinition') {
      return true;
    }
    const name = definition.name.value;
    if (names[name]) {
      return false;
    } else {
      names[name] = true;
      return true;
    }
  });
};
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { rewriteObjectPropertiesAsMap } from './utils';
import { BACKGROUND_REFRESH_INTERVAL_TIME, DEFAULT_BOARD_PAGE_SIZE, MAX_BOARD_PAGE_SIZE } from './constants';
import { useApolloClient, useQuery, gql } from '@apollo/client';
import { usePipeline, usePipelineId } from 'crm-object-board-core/pipeline';
import { useHandler } from '../handlers/useHandler';
import { useSyncError } from '../error/useSyncError';
import { createMaybeBoardCrmSearchError } from 'crm-object-search-query-utilities';
import { usePollWhenVisible } from 'crm-object-search-query-utilities/crmObjectSearch';
import { disableGlobalErrorReportingForMatches } from 'crm-object-search-query-utilities/errors/handledErrors';
import { useSearchQuery } from './generateSearchQuery/useSearchQuery';
import { useObjectTypeId } from 'crm-object-board-core/objectTypeDefinition';
import { useTriggerHandler } from '../handlers/useTriggerHandler';
import { CrmObjectBoardObjectFragment } from './fragments';
import { executeAtLowerPriority } from '../utils/executeAtLowerPriority';
export const CRM_SEARCH_QUERY = 'CRM_OBJECT_BOARD_CRM_SEARCH_QUERY';
export const CrmObjectBoardSearchQuery = ("__gql__", "{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"OperationDefinition\",\"operation\":\"query\",\"name\":{\"kind\":\"Name\",\"value\":\"CRM_OBJECT_BOARD_CRM_SEARCH_QUERY\"},\"variableDefinitions\":[{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"filterGroups\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"ListType\",\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"FilterGroup\"}}}}}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"sorts\"}},\"type\":{\"kind\":\"ListType\",\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"Sort\"}}}}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"query\"}},\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"String\"}}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"objectTypeId\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"String\"}}}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"properties\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"ListType\",\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"String\"}}}}}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"count\"}},\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"Int\"}}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"offset\"}},\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"Int\"}}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"stageIds\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"ListType\",\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"String\"}}}}}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"crmObjectsByPipelineStageSearch\"},\"arguments\":[{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"filterGroups\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"filterGroups\"}}},{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"sorts\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"sorts\"}}},{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"query\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"query\"}}},{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"type\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"objectTypeId\"}}},{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"count\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"count\"}}},{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"offset\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"offset\"}}},{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"stageIds\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"stageIds\"}}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"pipelineStageId\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"crmSearchPayload\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"hasMore\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"total\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"offset\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"results\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"FragmentSpread\",\"name\":{\"kind\":\"Name\",\"value\":\"CrmObjectBoardObjectFragment\"}}]}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"validationErrors\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"__typename\"}},{\"kind\":\"InlineFragment\",\"typeCondition\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"GenericValidationError\"}},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"message\"}}]}}]}}]}}]}}]}}]}", {
  id: null,
  kind: "Document",
  definitions: _unique([{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "CRM_OBJECT_BOARD_CRM_SEARCH_QUERY"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "filterGroups"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "ListType",
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "FilterGroup"
              }
            }
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "sorts"
        }
      },
      type: {
        kind: "ListType",
        type: {
          kind: "NonNullType",
          type: {
            kind: "NamedType",
            name: {
              kind: "Name",
              value: "Sort"
            }
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "query"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "String"
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "objectTypeId"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "String"
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "properties"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "ListType",
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "String"
              }
            }
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "count"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "Int"
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "offset"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "Int"
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "stageIds"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "ListType",
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "String"
              }
            }
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "crmObjectsByPipelineStageSearch"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "filterGroups"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "filterGroups"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "sorts"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "sorts"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "query"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "query"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "type"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "objectTypeId"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "count"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "count"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "offset"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "offset"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "stageIds"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "stageIds"
            }
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "pipelineStageId"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "crmSearchPayload"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "hasMore"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "total"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "offset"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "results"
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "FragmentSpread",
                    name: {
                      kind: "Name",
                      value: "CrmObjectBoardObjectFragment"
                    }
                  }]
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "validationErrors"
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "__typename"
                    }
                  }, {
                    kind: "InlineFragment",
                    typeCondition: {
                      kind: "NamedType",
                      name: {
                        kind: "Name",
                        value: "GenericValidationError"
                      }
                    },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "message"
                        }
                      }]
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }].concat(CrmObjectBoardObjectFragment.definitions))
});
export const useCrmSearch = () => {
  const objectTypeId = useObjectTypeId();
  const pipelineId = usePipelineId();
  const searchQuery = useSearchQuery();
  const fetchPolicyRef = useRef('no-cache');
  const lazilyWriteToCache = useRef(true);
  const triggerHandler = useTriggerHandler();
  //board specific properties
  const [count, setCount] = useState(DEFAULT_BOARD_PAGE_SIZE);
  //reset on pipeline change
  useEffect(() => {
    setCount(DEFAULT_BOARD_PAGE_SIZE);
  }, [pipelineId]);
  const pipeline = usePipeline();
  const stageIds = useMemo(() => pipeline ? pipeline.stages.map(({
    stageId
  }) => stageId) : [], [pipeline]);
  const skip = !pipeline;
  const client = useApolloClient();
  const variables = useMemo(() => Object.assign({}, searchQuery, {
    count,
    offset: 0,
    stageIds
  }), [searchQuery, count, stageIds]);
  const _useQuery = useQuery(CrmObjectBoardSearchQuery, {
      fetchPolicy: fetchPolicyRef.current,
      pollInterval: BACKGROUND_REFRESH_INTERVAL_TIME,
      skip,
      variables,
      onCompleted: response => {
        if (!lazilyWriteToCache.current) {
          return;
        }
        lazilyWriteToCache.current = false;
        executeAtLowerPriority(() => {
          fetchPolicyRef.current = 'cache-first';
          client.writeQuery({
            query: CrmObjectBoardSearchQuery,
            data: response,
            variables
          });
        });
      },
      context: {
        disableGlobalErrorReportingForMatches
      }
    }),
    {
      loading: rawLoading,
      data: rawData,
      previousData,
      error
    } = _useQuery,
    remainingResultFields = _objectWithoutPropertiesLoose(_useQuery, _excluded);

  // This ensures we return loading: false when apollo reports loading: true but also provides data.
  // This can occur when a refresh of the current query is triggered for any reason (such as polling).
  // It simply means that there is data that matches the current query in the cache and apollo is
  // refreshing the current query in the background. In these cases we do not want to render a
  // loading spinner, as we have valid data to show.
  const loading = rawLoading && !rawData;
  const pollInterval = BACKGROUND_REFRESH_INTERVAL_TIME;
  const {
    stopPolling,
    startPolling,
    refetch
  } = remainingResultFields;
  const loadMore = useCallback(() => {
    setCount(Math.min(count + DEFAULT_BOARD_PAGE_SIZE, MAX_BOARD_PAGE_SIZE));
  }, [setCount, count]);
  useHandler('onLoadMore', loadMore);
  usePollWhenVisible({
    pollInterval,
    startPolling,
    stopPolling,
    refetch
  });
  const data = useMemo(() => {
    const dataToUse = rawData || previousData;
    if (!dataToUse || !dataToUse.crmObjectsByPipelineStageSearch) {
      return [];
    }
    return dataToUse.crmObjectsByPipelineStageSearch.map(payload => {
      const results = payload.crmSearchPayload.results.reduce((result, item) => {
        var _mapped$properties$hs;
        const mapped = rewriteObjectPropertiesAsMap(item);
        //dont use items without object id
        if (!((_mapped$properties$hs = mapped.properties['hs_object_id']) !== null && _mapped$properties$hs !== void 0 && _mapped$properties$hs.value)) {
          return result;
        }
        //add mapped object to result
        result.push({
          id: mapped.objectId.toString(),
          data: mapped
        });
        return result;
      }, []);
      //results 9 original 10, diff - 1
      const diff = results.length - payload.crmSearchPayload.results.length;
      return {
        columnId: payload.pipelineStageId,
        total: payload.crmSearchPayload.total + diff,
        hasMore: payload.crmSearchPayload.hasMore,
        data: results
      };
    });
  }, [rawData, previousData]);
  const crmSearchError = useMemo(() => {
    return createMaybeBoardCrmSearchError({
      objectTypeId,
      rawData,
      rawError: error,
      crmSearchQueryObject: searchQuery
    });
  }, [error, objectTypeId, rawData, searchQuery]);
  useSyncError(crmSearchError);
  useEffect(() => {
    if (data) {
      const ids = [];
      data.forEach(col => {
        col.data.forEach(i => ids.push(i.id));
      });
      triggerHandler({
        key: 'onDataReceived',
        options: {
          ids
        }
      });
    }
  }, [data, triggerHandler]);
  return useMemo(() => {
    return {
      data,
      loading: loading && count === DEFAULT_BOARD_PAGE_SIZE || skip,
      loadingMore: loading && count !== DEFAULT_BOARD_PAGE_SIZE
    };
  }, [data, loading, count, skip]);
};